<template>
  <div class="mergeIssuePrint">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="发料详情"
        width="1200px"
        top="10vh"
        @close="handleClose">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="model"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <div class="vm-separate">
          <el-form-item label="生产订单号">
            <el-input v-model="model.orders" placeholder="系统自动生成" disabled/>
          </el-form-item>
          <el-form-item label="工单类型">
            <el-input v-model="model.orderTypeName" placeholder="系统自动生成" disabled/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="物料号">
            <el-input v-model="model.materialNo" placeholder="系统自动生成" disabled/>
          </el-form-item>
          <el-form-item label="物料描述">
            <el-input v-model="model.materialDescription" placeholder="系统自动生成" disabled/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="过账时间">
            <el-date-picker
                v-model="model.postTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="选择日期"/>
          </el-form-item>
          <el-form-item label="工厂">
            <el-input v-model="model.factoryName	" placeholder="系统自动生成" disabled/>
          </el-form-item>
        </div>
        <div>
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
            发料明细
          </div>
          <el-table
              :data="model.details"
              border
              style="width: 100%"
              show-summary
              :summary-method="getSummary">
            <el-table-column prop="rowIndex" align="center" label="行号" width="80"/>
            <el-table-column prop="materialCode" align="center" label="物料号" width="90"/>
            <el-table-column
                prop="materialDescription"
                align="center"
                label="物料描述"
                width="200"
                show-overflow-tooltip/>
            <el-table-column
                prop="specification"
                align="center"
                width="200"
                label="规格型号"
                show-overflow-tooltip/>
            <el-table-column prop="positionNo" align="center" label="存储地点" width="140">
              <template slot-scope="scope">
                <el-select v-model="scope.row.positionNo" placeholder="请选择">
                  <el-option
                      v-for="item in scope.row.stockList"
                      :key="item.lgort"
                      :label="item.lgobe"
                      :value="item.lgort"
                      @click.native="changePositionNo(item,scope.row)"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="locationNumber" align="center" label="库存" width="120"/>
            <el-table-column prop="locationNo" align="center" label="库存仓位" width="70"/>
            <el-table-column prop="specialFlag" align="center" label="库存类型" width="70"/>
            <el-table-column prop="specialStockNo" align="center" label="特殊库存" width="100">
              <template slot-scope="scope">
                <el-select v-if="scope.row.specialFlag==='寄售'" v-model="scope.row.specialStockNo" placeholder="请选择">
                  <el-option
                      v-for="item in scope.row.stockList"
                      :key="item.lifnr"
                      :label="item.lgobe"
                      :value="item.lifnr"/>
                </el-select>
                <el-select
                    v-else-if="scope.row.specialFlag==='客供'"
                    v-model="scope.row.specialStockNo"
                    placeholder="请选择">
                  <el-option
                      v-for="item in scope.row.stockList"
                      :key="item.labst"
                      :label="item.lgobe"
                      :value="item.kunnr"/>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="postNum" align="center" label="已过账数量" width="100"/>
            <el-table-column prop="requirementNum" align="center" label="需求数量" width="70"/>
            <el-table-column prop="thisPostNum" align="center" label="本次过账数量" width="120">
              <template slot-scope="scope">
                <el-input-number
                    v-model="scope.row.thisPostNum"
                    style="width: 100%"
                    :min="0"/>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <el-button type="info" @click="dialogVisible=false">关闭</el-button>
        <template v-if="model.details.length !== 0">
          <el-button type="success" @click="printProduction">打印</el-button>
          <el-button
              type="primary"
              :loading="saveLoading"
              @click="postProduction">提交</el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import constants from "@/util/constants";


  export default {
    name: "ProductionPost",
    components: {},
    data() {
      return {
        constant,
        constants,
        uploadLoading: false,
        dialogVisible: false,
        contentLoading: false,
        saveLoading: false,
        submitLoading: false,
        submitDisable: true,
        model: {
          orders: "",
          orderTypeName: "",
          materialNo: "",
          materialDescription: "",
          postTime: "",
        },
        ruleValidate: {},
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
        if (id > 0) {
          this.getData(id);
        }
      },
      getData(id) {
        this.$http.get("basic", `sapProductionOrders/selectPost/${id}`).then((resp) => {
          this.model = resp.data;
          this.model.details.forEach((item) => {
            item.thisPostNum = (item.requirementNum - item.postNum).toFixed(3);
          });
          this.model.postTime = this.getFormatDate(new Date());
        });
      },
      changePositionNo(item,row) {
        row.locationNumber = item.labst;
        row.positionNo = item.lgort;
      },



      // 获取当前时间
      getFormatDate(date) {
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate + " 00:00:00";
      },
      postProduction() {
        this.saveLoading = true;
        this.$http.post("basic", "sapProductionOrders/postProduction", this.model).then((res) => {
          console.log(res);
          if (res.success) {
            this.dialogVisible = false;
            this.$message.success("提交成功");
          }
          this.saveLoading = false;

        }).catch(() => {
          this.saveLoading = false;
          this.$message.success("提交失败");
        });
      },

      // 打印
      printProduction() {
        const routeUrl = this.$router.resolve({
          path: "/productManageOrderPrint",
          query: {
            ids: JSON.stringify(this.model.orders),
            printType: 3,
          },
        });
        window.open(routeUrl.href, "_blank");
      },

      getSummary({ columns, data }) {
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (column.property === "postNum" || column.property === "requirementNum" || column.property === "thisPostNum") {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = "";
          }
        });
        return sums;
      },

      handleClose() {
        this.$nextTick(() => {
          this.$reset("form");
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.mergeIssuePrint {
  .el-form-item__content {
    margin-left: 2% !important;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border: 1px solid #EBEEF5;
    border-bottom: none;
    border-left: none;
    margin-bottom: 15px;
  }

  table.gridtable tr td {
    padding: 8px;
    border-left: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

}

</style>
